import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueEvents from "vue-events";
import VueRouter from 'vue-router';
import store from "./store"

// Import Bootstrap an BootstrapVue CSS files (order is important)
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import Positions from "./apps/positions/Positions";
import PositionsOrganic from "./apps/positions/PositionsOrganic";
import Keywords from "./apps/keywords/Keywords";
import Usp from "./apps/usp/Usp";
import Wordstat from "./apps/wordstat/WSReportContainer";
import AutoLogin from "./apps/auth/AutoLogin";
import StaggeredAnimationsDemo from "./components/StaggeredAnimationsDemo";

// Yandex.Metrika counter
(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
m[i].l=1*new Date();
for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
clickmap:true,
trackLinks:true,
accurateTrackBounce:true,
webvisor:true
});

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
// Add Events
Vue.use(VueEvents);
Vue.use(VueRouter);



import App from "./App";
import redirectToLogin from "./apps/auth/redirect-to-login";

const router = new VueRouter({
  routes: [
      { path: '/', component: Positions, name: 'positions'},
      { path: '/keywords', component: Keywords, name: 'keywords' },
      { path: '/organic', component: PositionsOrganic, name: 'organic' },
      { path: '/usp', component: Usp, name: 'usp' },
      { path: '/ws', component: Wordstat, name: 'ws'},
      { path: '/auth/auto-login', component: AutoLogin, name: 'auto-login'},
      { path: '/demo/animations', component: StaggeredAnimationsDemo, name: 'animations-demo'},
    ]
});

/**
 * Проверка сессии до монтирования приложения.
 * При истёкшей/пустой сессии редирект на логин без показа основной страницы.
 */
async function ensureSessionThenMount() {
  const res = await fetch('/api/v1/current-user/', { credentials: 'same-origin' });
  if (res.status === 401 || res.status === 403) {
    redirectToLogin();
    return;
  }
  if (res.ok) {
    const ct = res.headers.get('content-type');
    if (!ct || !ct.includes('application/json')) {
      redirectToLogin();
      return;
    }
  }
  /* eslint-disable no-new */
  new Vue({
    store,
    router,
    render: h => h(App)
  }).$mount("#app");
}

ensureSessionThenMount();
